import axios, { AxiosInstance, AxiosResponse } from 'axios';

declare const process: { env: { [key: string]: string | undefined } };

// Use environment variable or fallback to localhost for local development
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) {
    return envUrl;
  }
  // Default to local development server
  return 'http://localhost:3001/api';
};

const API_URL = getApiUrl();

const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de solicitudes
api.interceptors.request.use(
  (config) => {
    if ((config.url || '').includes('/departamentos')) {
      // [CÓDIGO MUERTO] Logging eliminado para producción
      /*
      #region agent log
      ...logging eliminado para producción...
      #endregion
      */
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor de respuestas
api.interceptors.response.use(
  (response: AxiosResponse) => {
    if ((response.config.url || '').includes('/departamentos')) {
      // #region agent log
      // ...logging eliminado para producción...
      // #endregion
    }
    return response;
  },
  async (error) => {
    if ((error?.config?.url || '').includes('/departamentos')) {
      // #region agent log
      // ...logging eliminado para producción...
      // #endregion
    }
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}/auth/refresh-token`, {
            refreshToken,
          });

          const { token } = response.data.data;
          localStorage.setItem('token', token);

          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  },
);

export default api;
